module.exports = __webpack_public_path__ + "static/img/2.ddb3681.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/2.png
// module id = MFoc
// module chunks = 0